/* ============================================================
   NLC Wishlist — localStorage + variant picker + cart add
   ============================================================ */

(function () {
  var STORAGE_KEY = 'nlc_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(handle) {
    return getWishlist().some(function (i) { return i.handle === handle; });
  }

  function addToWishlist(item) {
    var list = getWishlist();
    if (!list.some(function (i) { return i.handle === item.handle; })) {
      list.push(item); saveWishlist(list);
    }
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (i) { return i.handle !== handle; }));
  }

  function toggleWishlist(item) {
    if (isWishlisted(item.handle)) { removeFromWishlist(item.handle); return false; }
    addToWishlist(item); return true;
  }

  function updateBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('.nlc-wishlist-count').forEach(function (b) {
      b.textContent = count;
      count > 0 ? b.removeAttribute('hidden') : b.setAttribute('hidden', '');
    });
  }

  function syncHearts() {
    document.querySelectorAll('.nlc-wishlist-btn').forEach(function (btn) {
      var w = isWishlisted(btn.dataset.handle);
      btn.classList.toggle('is-wishlisted', w);
      btn.setAttribute('aria-label', w ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('nlc-wishlist-drawer');
    var overlay = document.getElementById('nlc-wishlist-overlay');
    if (!drawer) return;
    renderDrawerBody();
    drawer.getBoundingClientRect();
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    var drawer = document.getElementById('nlc-wishlist-drawer');
    var overlay = document.getElementById('nlc-wishlist-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
  }

  function fetchVariants(handle, callback) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(null, data); })
      .catch(function (e) { callback(e, null); });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Find which option position is the filler material (0-indexed)
  // Looks for 'Filler material' option name, falls back to option1
  function getFillerOptionIndex(product) {
    if (!product.options) return 0;
    for (var i = 0; i < product.options.length; i++) {
      var name = product.options[i].name || '';
      if (name.toLowerCase().indexOf('fill') !== -1 || name.toLowerCase().indexOf('material') !== -1) {
        return i;
      }
    }
    return 0; // fallback to option1
  }

  // Get the filler value from a variant based on option index
  function getFillerValue(variant, optionIndex) {
    var keys = ['option1', 'option2', 'option3'];
    return variant[keys[optionIndex]] || variant.option1;
  }

  function addToCart(variantId, btn, itemEl) {
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cartCount = document.querySelector('cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
            cart.item_count > 0 ? cartCount.removeAttribute('hidden') : cartCount.setAttribute('hidden', '');
          }
        });
      var actionsEl = itemEl.querySelector('.nlc-wishlist-item__actions');
      if (actionsEl) {
        actionsEl.innerHTML = '<span class="nlc-wishlist-atc-success">&#10003; Added to cart</span>';
        setTimeout(function () { renderDrawerBody(); }, 2000);
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Add to cart';
    });
  }

  function viewLink(handle) {
    return '<a href="/products/' + handle + '" class="nlc-wishlist-item__view">View <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a>';
  }

  function buildItemActions(itemEl, handle) {
    var actionsEl = itemEl.querySelector('.nlc-wishlist-item__actions');
    var priceEl = itemEl.querySelector('.nlc-wishlist-item__price');
    if (!actionsEl) return;
    actionsEl.innerHTML = '<span class="nlc-wishlist-atc-loading">Loading...</span>';

    fetchVariants(handle, function (err, product) {
      if (err || !product || !product.variants) {
        actionsEl.innerHTML = viewLink(handle);
        return;
      }

      var variants = product.variants;
      var availableVariants = variants.filter(function (v) { return v.available; });

      if (availableVariants.length === 0) {
        actionsEl.innerHTML = '<span class="nlc-wishlist-atc-soldout">Sold out</span>&nbsp;' + viewLink(handle);
        return;
      }

      // Find which option position is the filler
      var fillerIndex = getFillerOptionIndex(product);

      // Deduplicate on filler option value
      var seen = {};
      var fillerGroups = [];
      availableVariants.forEach(function (v) {
        var key = getFillerValue(v, fillerIndex);
        if (!seen[key]) {
          seen[key] = true;
          fillerGroups.push({ label: key, variantId: v.id, price: v.price });
        }
      });

      // Set initial price from first available filler option
      if (priceEl && fillerGroups.length > 0) {
        priceEl.textContent = formatMoney(fillerGroups[0].price);
      }

      if (fillerGroups.length === 1) {
        // Single fill option — direct add
        var v = availableVariants[0];
        actionsEl.innerHTML = '<button class="nlc-wishlist-atc-btn" data-variant-id="' + v.id + '">Add to cart</button>&nbsp;' + viewLink(handle);
        actionsEl.querySelector('.nlc-wishlist-atc-btn').addEventListener('click', function () {
          addToCart(v.id, this, itemEl);
        });
      } else {
        // Multiple fill options — show dropdown
        var selectHtml = '<select class="nlc-wishlist-variant-select">';
        fillerGroups.forEach(function (g) {
          selectHtml += '<option value="' + g.variantId + '" data-price="' + g.price + '">' + g.label + '</option>';
        });
        selectHtml += '</select>';
        actionsEl.innerHTML = selectHtml + '<button class="nlc-wishlist-atc-btn">Add to cart</button>&nbsp;' + viewLink(handle);

        var select = actionsEl.querySelector('.nlc-wishlist-variant-select');

        select.addEventListener('change', function () {
          var selectedOption = select.options[select.selectedIndex];
          if (priceEl && selectedOption.dataset.price) {
            priceEl.textContent = formatMoney(parseInt(selectedOption.dataset.price));
          }
        });

        actionsEl.querySelector('.nlc-wishlist-atc-btn').addEventListener('click', function () {
          addToCart(parseInt(select.value), this, itemEl);
        });
      }
    });
  }

  function renderDrawerBody() {
    var list = getWishlist();
    var body = document.getElementById('nlc-wishlist-drawer-body');
    if (!body) return;

    var subtitle = document.querySelector('.nlc-wishlist-drawer__subtitle');
    if (subtitle) {
      subtitle.textContent = list.length === 0
        ? 'Save your favourites and shop them later'
        : list.length === 1 ? '1 saved item' : list.length + ' saved items';
    }

    if (list.length === 0) {
      body.innerHTML =
        '<div class="nlc-wishlist-empty">'
        + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
        + '<p>Your wishlist is empty</p>'
        + '<span>Heart a product to save it here</span>'
        + '<a href="/collections/all" class="btn btn--primary" style="margin-top:8px">Browse cushions</a>'
        + '</div>';
      return;
    }

    var html = '<ul class="nlc-wishlist-items">';
    list.forEach(function (item) {
      html += '<li class="nlc-wishlist-item" data-handle="' + item.handle + '">';
      html += '<a href="/products/' + item.handle + '" class="nlc-wishlist-item__image-link">';
      if (item.image) html += '<img src="' + item.image + '" alt="' + item.title + '" class="nlc-wishlist-item__img" width="80" height="80" loading="lazy">';
      html += '</a>';
      html += '<div class="nlc-wishlist-item__info">';
      html += '<a href="/products/' + item.handle + '" class="nlc-wishlist-item__title">' + item.title + '</a>';
      if (item.price) html += '<span class="nlc-wishlist-item__price">' + item.price + '</span>';
      html += '<div class="nlc-wishlist-item__actions"></div>';
      html += '</div>';
      html += '<button class="nlc-wishlist-item__remove" data-handle="' + item.handle + '" aria-label="Remove">';
      html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      html += '</button></li>';
    });
    html += '</ul>';

    html += '<a href="/pages/styling-services" class="nlc-wishlist-cta">';
    html += '<div class="nlc-wishlist-cta__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#d97b61" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>';
    html += '<div class="nlc-wishlist-cta__text"><span class="nlc-wishlist-cta__heading">Need help choosing?</span><span class="nlc-wishlist-cta__sub">Our styling team can find your perfect match.</span></div>';
    html += '<span class="nlc-wishlist-cta__arrow">Book &rarr;</span>';
    html += '</a>';

    html += '<div class="nlc-wishlist-clear-wrap"><button class="nlc-wishlist-clear">Clear wishlist</button></div>';

    body.innerHTML = html;

    body.querySelectorAll('.nlc-wishlist-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromWishlist(btn.dataset.handle);
        updateBadge(); syncHearts(); renderDrawerBody();
      });
    });

    var clearBtn = body.querySelector('.nlc-wishlist-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        saveWishlist([]); updateBadge(); syncHearts(); renderDrawerBody();
      });
    }

    body.querySelectorAll('.nlc-wishlist-item').forEach(function (itemEl) {
      buildItemActions(itemEl, itemEl.dataset.handle);
    });
  }

  function init() {
    var drawer = document.getElementById('nlc-wishlist-drawer');
    var overlay = document.getElementById('nlc-wishlist-overlay');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nlc-wishlist-btn');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var item = { handle: btn.dataset.handle, title: btn.dataset.title, image: btn.dataset.image, price: btn.dataset.price };
      var added = toggleWishlist(item);
      btn.classList.toggle('is-wishlisted', added);
      btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
      btn.classList.add('nlc-wishlist-btn--pop');
      setTimeout(function () { btn.classList.remove('nlc-wishlist-btn--pop'); }, 300);
      updateBadge();
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.nlc-wishlist-trigger')) { e.preventDefault(); openDrawer(); }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.nlc-wishlist-close') || e.target.id === 'nlc-wishlist-overlay') closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    updateBadge();
    syncHearts();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  window.NLCWishlist = { getWishlist: getWishlist, isWishlisted: isWishlisted, syncHearts: syncHearts, updateBadge: updateBadge, openDrawer: openDrawer };
})();
